<template>
    <div id="data-list-list-view" class="data-list-container">
     
                       
        <div class="vx-row">
            <div class="vx-col lg:w-1/4" >
                <label for="from" class="vs-input--label"> {{$t('From')}}</label>
                <datepicker  :placeholder="$t('From')" v-model="search.StartDate" class="vx-col  w-full" name="from" v-validate="'required'"></datepicker>    
            </div>
            <div class="vx-col lg:w-1/4" >
                <label for="to" class="vs-input--label"> {{$t('To')}}</label>
                <datepicker  :placeholder="$t('To')" v-model="search.EndDate" class="vx-col  w-full" name="to" v-validate="'required'"></datepicker> 
            </div>
            <div class="vx-col lg:w-1/4" >
              <p>{{$t('Course')}}</p>
             <v-select
                                          label="Name"
                                          class=" w-full"
                                            autocomplete
                                          v-model="search.CourseID"
                                          :options="Courses"
                                          :reduce="ID => ID.ID"
                                        />
                <!-- <vs-select autocomplete class=" w-full" label="Course "  v-model="search.CourseID" >
                        <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in Courses" />
                </vs-select> -->
            </div> 
            <div class="vx-col lg:w-1/4" >
             <p>{{$t('Instructor')}}</p>
             <v-select
                                          label="Name"
                                          class=" w-full"
                                            autocomplete
                                          v-model="search.InstructorID"
                                          :options="Instructors"
                                          :reduce="ID => ID.ID"
                                        />
           
            </div> 
            <vs-button type="border" icon-pack="feather" class="mt-5" icon="icon-search" @click="ViewSearch">{{$t('Search')}}</vs-button>
        </div>
         <vx-card v-if="questions.length>0" style="margin-top:20px">
            <h2>Total Questions : {{questions.length}}</h2> 
                    <!-- CARD ACTION -->
               
                    <!-- Chart -->
                    <!-- <div slot="no-body">
                        <vue-apex-charts type=radialBar height=255 width=500 :options="analyticsData.productOrdersRadialBar.chartOptions" :series="UserSeries" />
                    </div> -->
                    <br/>
                    <label>from 0 to 50 % </label>
                    <vx-tooltip  :text="(ListGreterThanZero.length*100)/questions.length+' %'">
                <vs-progress class="block mt-1" :percent="(ListGreterThanZero.length*100)/questions.length" color="primary"></vs-progress>
                
            </vx-tooltip>
                  <br/>
                    <label>from 50 to 80 %</label>
                     <vx-tooltip  :text="(ListGreterThanTheHalf.length*100)/questions.length +' %'">
                  <vs-progress class="block mt-1" :percent="(ListGreterThanTheHalf.length*100)/questions.length" color="warning"></vs-progress>
                    </vx-tooltip>
                    <br/>
                    <label>from 80 to 100 %</label>
                     <vx-tooltip  :text="(ListLessThanHandred.length*100)/questions.length+' %'">
                  <vs-progress class="block mt-1" :percent="(ListLessThanHandred.length*100)/questions.length" color="danger"></vs-progress>
                    </vx-tooltip>
                    <br/>
                    <ul>
                        <li v-for="orderData in UserVisit" :key="orderData.orderType" class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid" :class="`border-${orderData.color}`"></span>
                                    <span class="font-semibold">{{ orderData.orderType }}</span>
                            </span>
                            <span>{{ orderData.counts }}</span>
                        </li>
                    </ul>
                </vx-card>
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="questions">
        <template slot="thead">
            <vs-th sort-key="Name">{{$t('Question')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Course')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Module')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Instructor')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Pass')}} %</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                    <p class="product-name font-medium ">{{ tr.QuestionTest }}</p>
                </vs-td>
                <vs-td>
                    <p class="product-name font-medium ">{{ tr.CourseName }}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                    <p class="product-name font-medium ">{{ tr.ModuleName }}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                    <p class="product-name font-medium ">{{ tr.InstructorName }}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                    <vx-tooltip :text="tr.PassPercentage+ ' %'" position="top">
                                <vs-progress class="block mt-1" :percent="tr.PassPercentage" color="primary"></vs-progress>
                    </vx-tooltip>
                    <!-- <p class="product-name font-medium truncate">{{ tr.PassPercentage }}%</p> -->
                </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    </div>  
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleInstructor from "@/store/instructor/moduleInstructor.js";
import moduleCourseClassExam from "@/store/courseClassExam/moduleCourseClassExam.js";
import vSelect from 'vue-select';
export default {

    components: {
        Datepicker,
        vSelect
    },
    computed:{
        questions:{
      get() {
             return this.$store.state.courseClassExamList.questions;
        },
      
    },
       Courses() {
         return this.$store.state.courseList.courses;
      },
       Instructors() {
          return this.$store.state.instructorList.instructors;
        }
    },
    data(){
        return{
            itemsPerPage: 10,
            search:{},
            UserVisit: [
              {
                color: "primary",
                orderType: "from 0 to 50 %",
                counts: 0,
                
              },
              {
                color: "warning",
                 orderType: "from 50 to 80 %",
                counts: 0,
              },
              {
                color: "danger",
                 orderType: "from 80 to 100 %",
                counts: 0,
              },
              
            ],
            UserSeries:[],
            ListGreterThanZero:[],
            ListGreterThanTheHalf:[],
            ListLessThanHandred:[],
        }
    },
    methods:{
        ViewSearch()
        {
          debugger
          this.ListGreterThanZero=[];
            this.ListGreterThanTheHalf=[];
            this.ListLessThanHandred=[];
          this.UserVisit[0].counts=0;
              this.UserVisit[1].counts=0;
               this.UserVisit[2].counts=0;
                this.$vs.loading();
            this.$store.dispatch("courseClassExamList/GetQuestionPassStatistic",  this.search).then(()=>{
               this.$vs.loading.close();
           this.questions.forEach(element => {
             if(element.PassPercentage>=0&&element.PassPercentage<50){
               this.ListGreterThanZero.push(element);
               this.UserVisit[0].counts=this.ListGreterThanZero.length;
              this.UserVisit[1].counts=this.ListGreterThanTheHalf.length;
               this.UserVisit[2].counts=this.ListLessThanHandred.length;
             }
             if(element.PassPercentage>=50&&element.PassPercentage<80){
               this.ListGreterThanTheHalf.push(element);
               this.UserVisit[0].counts=this.ListGreterThanZero.length;
              this.UserVisit[1].counts=this.ListGreterThanTheHalf.length;
               this.UserVisit[2].counts=this.ListLessThanHandred.length;
             }
             if(element.PassPercentage>=80&&element.PassPercentage<=100){
               this.ListLessThanHandred.push(element);
               this.UserVisit[0].counts=this.ListGreterThanZero.length;
              this.UserVisit[1].counts=this.ListGreterThanTheHalf.length;
               this.UserVisit[2].counts=this.ListLessThanHandred.length;
             }
           });
        // this.UserSeries[0] = ((res.data.UniqueNumber*100)/this.totalUsers).toFixed(2)
        // this.UserVisit[0].counts=res.data.UniqueNumber
        //  this.UserSeries[1] = ((res.data.NumberOfVisits*100)/this.totalUsers).toFixed(2)
        //  this.UserVisit[1].counts=res.data.NumberOfVisits
        //   this.UserSeries[2] = (((this.totalUsers-res.data.UniqueNumber)*100)/this.totalUsers).toFixed(2)
        //   this.UserVisit[2].counts=this.totalUsers-res.data.UniqueNumber
          
            }).catch(err => {
              this.$vs.loading.close();
            });
        }
    },
    created()
    {
        if (!moduleCourse.isRegistered) {
            this.$store.registerModule("courseList", moduleCourse);
            moduleCourse.isRegistered = true;
            }
            this.$store.dispatch("courseList/fetchDataListItems");

            if (!moduleInstructor.isRegistered) {
                this.$store.registerModule("instructorList", moduleInstructor);
                moduleInstructor.isRegistered = true;
            }
            this.$store.dispatch("instructorList/fetchDataListItems");

             if (!moduleCourseClassExam.isRegistered) {
      this.$store.registerModule("courseClassExamList", moduleCourseClassExam);
      moduleCourseClassExam.isRegistered = true;
    }
    }
}
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
